import { h } from 'preact'
import { useState } from 'preact/hooks'
import { connect } from 'unistore/preact'
import { goBack } from '@sodra/prutt'
import { BasicDialog, Form, SpacerVertical } from '@sodra/bongo-ui'
import { ColorInput } from './ColorInput'
import { updateProject } from '../../../actions/projects.js'
import { store } from '../../../store.js'

const incRefreshVersion = () => {
  const refreshVersion = store.getState().refreshVersion || 0
  store.setState({ refreshVersion: refreshVersion + 1 })
}

const EditDefaultColor = ({ project, isUpdatingProject }) => {
  const [color, setColor] = useState(project.defaultColor)

  const handleSubmit = async () => {
    if (await updateProject({ defaultColor: color })) {
      incRefreshVersion()
      onClose()
    }
  }

  const onClose = () => goBack(`/projects/${project.id}/colors`)

  return (
    <BasicDialog
      disableAutofocus
      title="Ändra färg"
      primaryActionText="Spara"
      primaryActionLoading={isUpdatingProject}
      onPrimaryActionClick={handleSubmit}
      action1Text="Avbryt"
      onAction1Click={onClose}
      onClose={onClose}
    >
      <Form onSubmit={handleSubmit}>
        <ColorInput label="Färg" value={color} onChange={setColor} />
      </Form>
      <SpacerVertical />
    </BasicDialog>
  )
}

export default connect('project, isUpdatingProject')(EditDefaultColor)
